(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 if (reduced.matches) return;
 const english = document.documentElement.lang.startsWith('en');
 if (document.querySelector('.wr-effects')) {

  const visitKey = 'wild-rose-entered-v1';
  let visited = false;
  try { visited = sessionStorage.getItem(visitKey) === 'true'; } catch (_) {}
  const remember = () => { try { sessionStorage.setItem(visitKey, 'true'); } catch (_) {} };
  const intro = document.createElement('div');
  intro.className = 'wr-cinema';
  intro.setAttribute('role', 'dialog');
  intro.setAttribute('aria-label', 'Wild Rose');
  intro.setAttribute('aria-modal', 'true');
  for (const side of ['left', 'right']) {
    const vine = document.createElement('img');
    vine.className = `wr-cinema-vine wr-cinema-vine--${side}`;
    vine.alt = '';
    vine.setAttribute('aria-hidden', 'true');
    vine.src = new URL('wild-rose-intro-vine.png', document.currentScript.src).href;
    intro.append(vine);
  }
  const video = document.createElement('video');
  video.className = 'wr-cinema-video';
  video.src = new URL('wild-rose-intro.mp4', document.currentScript.src).href;
  video.muted = true;
  video.defaultPlaybackRate = 2;
  video.playbackRate = 2;
  video.playsInline = true;
  video.preload = 'auto';
  video.setAttribute('aria-hidden', 'true');
  intro.append(video);
  const name = document.createElement('img');
  name.className = 'wr-cinema-name';
  name.alt = 'Wild Rose';
  name.src = document.currentScript.dataset.wordmark || new URL('wild-rose-wordmark.png', document.currentScript.src).href;
  name.width = 2172; name.height = 724;
  const enter = document.createElement('button');
  enter.className = 'wr-cinema-enter';
  enter.setAttribute('aria-label', english ? 'Enter site and play music' : 'Siteye gir ve müziği başlat');
  enter.append(name);
  const hint = document.createElement('span');
  hint.className = 'wr-cinema-hint';
  hint.textContent = english ? 'Touch to enter' : 'Girmek için dokun';
  enter.append(hint);
  const skip = document.createElement('button');
  skip.className = 'wr-cinema-skip';
  skip.type = 'button';
  enter.type = 'button';
  skip.textContent = english ? 'Skip intro' : 'Girişi atla';
  const music = document.querySelector('.wr-music-toggle');
  intro.append(enter, skip);
  document.body.append(intro);
  const previous = document.activeElement;
  let closing = false;
  let playing = false;
  let watchdog;
  const finish = (duration = 750) => {
    if (closing) return;
    closing = true;
    remember();
    clearTimeout(watchdog);
    intro.style.setProperty('--wr-exit-duration', duration + 'ms');
    intro.classList.add('is-closing');
    enter.disabled = true;
    skip.disabled = true;
    setTimeout(() => {
      video.pause();
      intro.remove();
      if (previous instanceof HTMLElement && document.activeElement === document.body) previous.focus({preventScroll:true});
    }, duration);
  };
  video.addEventListener('timeupdate', () => {
    enter.style.opacity = String(1 - Math.max(0, Math.min(1, (video.currentTime - 1.35) / .55)));
    const progress = Math.max(0, Math.min(1, (video.currentTime - 1.6) / 2.4));
    intro.style.opacity = String(1 - progress * progress * (3 - 2 * progress));
  });
  video.addEventListener('ended', () => finish(0));
  video.addEventListener('error', () => { if (playing) finish(); });
  video.addEventListener('playing', () => intro.classList.add('is-playing'));
  skip.addEventListener('click', () => finish());
  const start = (withMusic = false) => {
    if (closing || playing) return;
    playing = true;
    remember();
    enter.disabled = true;
    if (withMusic && music) document.dispatchEvent(new CustomEvent('wild-rose:music-start'));
    watchdog = setTimeout(() => finish(), 8000);
    video.play().catch(() => finish());
  };
  enter.addEventListener('click', () => start(true));
  intro.addEventListener('keydown', e => {
    if (e.key === 'Escape') finish();
    if (e.key === 'Tab') {
      e.preventDefault();
      (playing || document.activeElement === enter ? skip : enter).focus();
    }
  });
  if (visited) start();
  else enter.focus({preventScroll:true});

 }
 const reset = () => document.documentElement.classList.remove('wr-leaving');
 window.addEventListener('pageshow', reset);
 document.addEventListener('click', event => {
  const link = event.target.closest('a[href]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target || link.hasAttribute('download') || reduced.matches) return;
  const next = new URL(link.href, location.href);
  if (next.origin !== location.origin || next.pathname === location.pathname || !/\/collections(?:\/|$)/.test(next.pathname)) return;
  event.preventDefault();
  document.documentElement.classList.add('wr-leaving');
  setTimeout(() => location.assign(next.href), 380);
  setTimeout(reset, 1800);
 });
})();








